export interface ComicCategory {
  name: string;
  en: string;
  icon: string;
  desc: string;
  count: string;
}

export interface ComicSeries {
  id: string;
  title: string;
  author: string;
  genre: string;
  chapters: string;
  status: string;
  score: string;
  desc: string;
  cover: string;
}

export interface ComicPanel {
  caption: string;
  src: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const comicCategories: ComicCategory[] = [
  {
    name: "冒险远征",
    en: "Adventure",
    icon: "ri-compass-3-line",
    desc: "探索未知世界，一路风尘仆仆",
    count: "128 部",
  },
  {
    name: "科幻未来",
    en: "Sci-Fi",
    icon: "ri-rocket-2-line",
    desc: "墨色星海，想象力的边缘",
    count: "96 部",
  },
  {
    name: "民俗怪谈",
    en: "Folklore",
    icon: "ri-moon-clear-line",
    desc: "灯下怪谈，旧日传说",
    count: "74 部",
  },
  {
    name: "武侠江湖",
    en: "Wuxia",
    icon: "ri-sword-line",
    desc: "快意恩仇，快马轻裘",
    count: "152 部",
  },
  {
    name: "校园日常",
    en: "Slice of Life",
    icon: "ri-bike-line",
    desc: "汽水与十七岁的夏天",
    count: "88 部",
  },
  {
    name: "悬疑推理",
    en: "Mystery",
    icon: "ri-search-eye-line",
    desc: "红绳牵线，真相待解",
    count: "63 部",
  },
];

export const comicSeries: ComicSeries[] = [
  {
    id: "iron-box",
    title: "铁盒远征",
    author: "陆离",
    genre: "冒险远征",
    chapters: "全 86 话",
    status: "已完结",
    score: "9.4",
    desc: "一只沉甸甸的铁盒，一支不按常理出牌的远征小队，穿越沙海与旧王国的遗迹，只为把盒里的秘密带回家。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20printed%20comic%20book%20cover%20of%20a%20small%20expedition%20team%20with%20a%20worn%20metal%20strongbox%20crossing%20a%20vast%20desert%2C%20retro%201980s%20chinese%20adventure%20comic%20art%2C%20halftone%20dot%20printing%20grain%2C%20aged%20warm%20cream%20paper%20texture%2C%20rust%20red%20amber%20and%20deep%20ink%20colors%2C%20dramatic%20paneled%20composition%2C%20no%20text&width=440&height=600&seq=comic-ironbox-01&orientation=portrait",
  },
  {
    id: "paper-lantern",
    title: "纸灯夜行",
    author: "砚生",
    genre: "民俗怪谈",
    chapters: "连载中 · 42 话",
    status: "热读",
    score: "9.6",
    desc: "一盏会自己点亮的旧纸灯，引着少年夜行穿过古镇长街。每一盏灯后，都藏着一个不愿离去的故人。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20printed%20comic%20book%20cover%20of%20an%20old%20paper%20lantern%20floating%20over%20a%20misty%20ancient%20alley%20at%20dusk%2C%20mysterious%20folk%20horror%20story%20mood%2C%20retro%20chinese%20ink%20comic%20art%2C%20halftone%20print%20grain%2C%20aged%20cream%20paper%2C%20rust%20red%20and%20warm%20amber%20palette%2C%20no%20text&width=440&height=600&seq=comic-lantern-02&orientation=portrait",
  },
  {
    id: "ink-galaxy",
    title: "墨色星际",
    author: "回声",
    genre: "科幻未来",
    chapters: "全 64 话",
    status: "已完结",
    score: "9.1",
    desc: "当星空被画成墨色，一艘老旧的星船在琥珀色星云里缓慢航行。乘客们带上了所有舍不得丢掉的旧物。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20printed%20comic%20book%20cover%20of%20a%20retro%20star%20ship%20sailing%20through%20ink-black%20space%20with%20amber%20nebula%2C%20retro%201980s%20science%20fiction%20comic%20art%2C%20halftone%20dot%20printing%2C%20aged%20cream%20paper%20texture%2C%20warm%20rust%20and%20amber%20palette%20against%20deep%20ink%2C%20no%20text&width=440&height=600&seq=comic-galaxy-03&orientation=portrait",
  },
  {
    id: "rust-sword",
    title: "锈剑江湖",
    author: "迟暮",
    genre: "武侠江湖",
    chapters: "全 120 话",
    status: "已完结",
    score: "9.3",
    desc: "一把生了锈的剑，一个不肯再拔剑的刀客。江湖依旧，只是人不再年轻。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20printed%20comic%20book%20cover%20of%20a%20swordsman%20holding%20a%20rusty%20blade%20standing%20on%20a%20rainy%20old%20stone%20bridge%2C%20retro%20chinese%20wuxia%20comic%20art%2C%20halftone%20print%20grain%2C%20aged%20warm%20paper%2C%20ink%20and%20rust%20red%20palette%2C%20dramatic%20silhouette%2C%20no%20text&width=440&height=600&seq=comic-sword-04&orientation=portrait",
  },
  {
    id: "soda-seventeen",
    title: "汽水与十七岁",
    author: "栀子",
    genre: "校园日常",
    chapters: "连载中 · 58 话",
    status: "暖甜",
    score: "9.2",
    desc: "夏天的天台，一瓶冰汽水，还有写在作文纸背面的心事。那是关于喜欢、退让与重新出发的十七岁。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20printed%20comic%20book%20cover%20of%20a%20teenage%20girl%20holding%20a%20glass%20soda%20bottle%20on%20a%20summer%20school%20rooftop%2C%20retro%201980s%20youth%20daily-life%20comic%20art%2C%20halftone%20print%2C%20aged%20cream%20paper%2C%20warm%20amber%20and%20rust%20red%20tones%2C%20no%20text&width=440&height=600&seq=comic-soda-05&orientation=portrait",
  },
  {
    id: "red-thread",
    title: "红绳迷案",
    author: "十方",
    genre: "悬疑推理",
    chapters: "连载中 · 36 话",
    status: "热读",
    score: "9.0",
    desc: "一把红绳把三桩看似无关的旧案系在了一起。侦探在泛黄的档案里，翻出了被墨水盖住的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20printed%20comic%20book%20cover%20of%20a%20red%20string%20connecting%20clues%20over%20a%20dark%20study%20desk%20with%20a%20magnifying%20glass%2C%20retro%20detective%20comic%20art%2C%20halftone%20print%20grain%2C%20aged%20cream%20paper%2C%20deep%20ink%20and%20rust%20red%20palette%2C%20no%20text&width=440&height=600&seq=comic-thread-06&orientation=portrait",
  },
];

export const readingPanels: ComicPanel[] = [
  {
    caption: "夜市的灯笼摊亮起第一盏灯",
    src: "https://readdy.ai/api/search-image?query=retro%20printed%20comic%20page%20panel%20of%20a%20glowing%20lantern%20stall%20at%20a%20night%20market%2C%20warm%20amber%20light%2C%20folk%20story%20illustration%2C%20halftone%20print%20grain%2C%20aged%20cream%20paper%2C%20no%20text&width=600&height=460&seq=panel-nightmarket-01&orientation=landscape",
  },
  {
    caption: "纸船顺着月光漂过古镇河道",
    src: "https://readdy.ai/api/search-image?query=retro%20printed%20comic%20page%20panel%20of%20a%20paper%20boat%20drifting%20along%20an%20old%20town%20river%20under%20moonlight%2C%20folk%20ink%20comic%2C%20halftone%20grain%2C%20aged%20paper%2C%20warm%20tones%2C%20no%20text&width=600&height=460&seq=panel-river-02&orientation=landscape",
  },
  {
    caption: "长街尽头，一盏灯亮了起来",
    src: "https://readdy.ai/api/search-image?query=retro%20printed%20comic%20page%20panel%20of%20a%20lantern-lit%20doorway%20in%20an%20old%20alley%20with%20a%20mysterious%20figure%2C%20ink%20comic%2C%20halftone%20grain%2C%20aged%20paper%2C%20warm%20rust%20and%20amber%20palette%2C%20no%20text&width=600&height=460&seq=panel-alley-03&orientation=landscape",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "老周",
    role: "收藏向读者",
    text: "在纸盒上看漫画，真的像是把一本旧书摊在膝上。网点、纸纹、泛黄的边角都还原得恰到好处，画面比以前耐看得多。",
  },
  {
    name: "阿梨",
    role: "民俗题材爱好者",
    text: "《纸灯夜行》那种灯下的氛围感太戳我了，配上纸质滤镜，诡异又温柔，已经安利给身边一圈人。",
  },
  {
    name: "大宇",
    role: "实体书党",
    text: "找了很久这种接近翻书感的阅读入口。不用等到货，手机里就有一摞旧杂志的感觉，通勤路上也能静下心看两话。",
  },
  {
    name: "苏苏",
    role: "科幻漫迷",
    text: "纸质质感不是噱头，确实让墨色星际那种复古科幻的调子出来了。细节经得起放大，看久了也不累眼。",
  },
];

export const faqItems: FaqItem[] = [
  {
    q: "纸盒漫画网的「纸质原稿质感」到底是什么效果？",
    a: "我们在阅读界面叠加了泛黄纸色、印刷网点与轻微纸面噪点，还原实体书和原稿扫描的视觉质感，让画面层次更接近翻实体书时的感受，细节更耐看，而不是简单加一层滤镜。",
  },
  {
    q: "可以在电脑、平板和手机上阅读吗？",
    a: "可以。纸盒漫画网采用响应式布局，电脑、平板和手机都能获得一致的纸质阅读体验，导航与阅读界面会根据屏幕大小自动调整。",
  },
  {
    q: "喜欢复古漫画但没有指定的作品，从哪里开始？",
    a: "建议先逛逛「栏目分类」和「热门漫画」板块，按冒险、民俗、武侠等兴趣挑选。也可以从口碑高分的作品如《纸灯夜行》开始，比较有代表性。",
  },
  {
    q: "需要注册账号才能阅读吗？",
    a: "目前官网上新内容免费浏览，订阅「上新订阅」后可以在新作上线时第一时间收到通知，方便跟进喜欢的连载。",
  },
  {
    q: "内容多久更新一次？",
    a: "热门连载通常保持稳定的更新节奏，已完结作品一次可看完整话。不同作品更新频率略有差异，具体以上架信息为准。",
  },
  {
    q: "我有作品想投稿，应该怎么联系？",
    a: "欢迎通过页面下方的「联系我们」邮箱或订阅反馈与我们联系，我们很乐意和有原稿质感、复古风格想法的创作者交流合作。",
  },
];